








































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'
import {required} from "vuelidate/lib/validators";

import { CFMDTOWorkGroup } from '@/scripts/services/ClientApiAuto'

@Component<WorkGroupDialog>({
    components: {
    },
    validations() {
        return {
        workGroup:{
            Name: {required}
        }
        }
    },
})
export default class WorkGroupDialog extends CFMDialog {
    workGroup: CFMDTOWorkGroup = {Name: ''};

    selectedWorkGroup :CFMDTOWorkGroup = {Name: ''}

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.workGroup.workGroupGetById({id: <number>this.id});
        this.workGroup = res.data;
      }
    
      if(this.isUpdate){
      if(this.workGroup ){
          this.selectedWorkGroup  = this.workGroup;
      }
      }
      blockui.unBlockModal();
    }
    
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.workGroup.Id,
        Name: this.workGroup.Name
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.workGroup.workGroupSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
